import React, { useCallback, useEffect, useMemo } from 'react'
import { View } from '@/components'
import { FeedOptionsSelectorProps, ItemInfo } from './types'
import { OptionItem } from './RenderItem'

export const FeedOptionsSelector = <T extends ItemInfo>(props: FeedOptionsSelectorProps<T>) => {
  const { data, onValueChange, value, renderItem = OptionItem } = props

  const defaultIndex = useMemo(() => {
    const index = data.findIndex(option => option.value === value?.value)
    return index !== -1 ? index : 0
  }, [])

  useEffect(() => {
    if (!value) onValueChange(data[defaultIndex].value)
  }, [defaultIndex])

  const renderOption = useCallback(
    (option: T, index: number) => {
      const isSelected = option.value === value

      return renderItem({
        item: option,
        onSelectOption: () => onValueChange(option.value),
        selected: isSelected
      })
    },
    [value, renderItem, onValueChange]
  )

  return (
    <View variants={['column', 'gap:2']}>
      {data.map((option, index) => (
        <React.Fragment key={`${option.value}-${index}`}>{renderOption(option, index)}</React.Fragment>
      ))}
    </View>
  )
}
